import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle2, AlertTriangle, Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function WhatsAppSetup({ isAdmin }) {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => { api.get('/whatsapp/config').then(({ data }) => setCfg(data)).catch(() => setCfg(null)); }, []);
  useEffect(() => { load(); }, [load]);
  if (!cfg) return null;

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/whatsapp/config/connect');
      setCfg(data);
      toast.success('El número ahora envía sus mensajes a este BOMM');
    } catch (e) {
      toast.error(errText(e, 'No se pudo conectar'));
    } finally {
      setBusy(false);
    }
  };

  const ok = cfg.configured && cfg.connected_here;
  return (
    <Card className={`p-4 flex flex-wrap items-center gap-3 ${ok ? '' : 'border-amber-500/40'}`} data-testid="whatsapp-setup">
      {ok ? <CheckCircle2 className="h-5 w-5 text-emerald-400" /> : <AlertTriangle className="h-5 w-5 text-amber-400" />}
      <div className="text-sm flex-1 min-w-[260px]">
        <div className="font-medium" data-testid="whatsapp-setup-number">Número {cfg.number || '—'} · {cfg.sender_status || (cfg.configured ? '…' : 'sin configurar')}</div>
        <div className="text-xs text-[hsl(var(--muted-foreground))]" data-testid="whatsapp-setup-status">
          {!cfg.configured && 'Faltan las credenciales de Twilio en el servidor.'}
          {cfg.configured && ok && 'Los mensajes que llegan a este número los recibe este BOMM.'}
          {cfg.configured && !ok && (cfg.current_incoming_url
            ? `Los mensajes entrantes van a otra dirección: ${cfg.current_incoming_url}`
            : 'El número todavía no envía los mensajes entrantes a ningún BOMM.')}
          {cfg.error && ` (${cfg.error})`}
        </div>
        {cfg.hours_enabled && (
          <div className="text-xs mt-1" data-testid="whatsapp-hours-status">
            <span className={cfg.hours_open ? 'text-emerald-300' : 'text-amber-300'}>{cfg.hours_open ? 'Dentro de horario' : 'Fuera de horario'}</span>
            <span className="text-[hsl(var(--muted-foreground))]"> · Atención humana {cfg.hours_label}</span>
          </div>
        )}
      </div>
      {cfg.configured && !ok && isAdmin && (
        <Button size="sm" onClick={connect} disabled={busy} data-testid="whatsapp-connect-button">
          <Link2 className="h-4 w-4 mr-1" />{busy ? 'Conectando...' : 'Recibir los mensajes aquí'}
        </Button>
      )}
    </Card>
  );
}
